import SportData from './SportData'

export default SportData
